(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-page-snap"] && !Shopify.designMode) return;
  try {
    
/* Autoplay + integer height lock to avoid sub-pixel seams */
(() => {
  const root = document.getElementById('fp-snap-{{ section.id }}');
  if (!root) return;

  const track = root.querySelector('.fp-snap__container');
  const getHeader = () => {
    const v = getComputedStyle(root).getPropertyValue('--fp-header-offset') || '0';
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  const lockHeight = () => {
    const header = getHeader();
    const h = Math.max(0, Math.round(window.innerHeight - header));
    track.style.height = h + 'px';
  };

  lockHeight();
  let rid = null;
  const rq = () => { if (rid) cancelAnimationFrame(rid); rid = requestAnimationFrame(lockHeight); };
  window.addEventListener('resize', rq, { passive: true });
  window.addEventListener('orientationchange', rq);

  const videos = Array.from(root.querySelectorAll('video.fp-snap__video'));
  videos.forEach(v => {
    v.muted = true; v.loop = true; v.playsInline = true;
    try { v.setAttribute('muted', ''); } catch(e){}
    try { v.setAttribute('playsinline', ''); } catch(e){}
    try { v.setAttribute('webkit-playsinline', ''); } catch(e){}
    try { v.removeAttribute('controls'); } catch(e){}
    try { v.setAttribute('preload', 'auto'); } catch(e){}
  });

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio > 0.5) v.play().catch(() => {});
        else v.pause();
      });
    }, { root: track, threshold: [0, 0.5, 1] });
    videos.forEach(v => io.observe(v));
  } else {
    videos.forEach(v => v.play && v.play().catch(() => {}));
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(v => v.pause());
    else videos.forEach(v => v.play && v.play().catch(() => {}));
  });

  const unlock = () => {
    videos.forEach(v => v.play && v.play().catch(() => {}));
    window.removeEventListener('touchstart', unlock, { passive: true });
    window.removeEventListener('click', unlock, true);
  };
  window.addEventListener('touchstart', unlock, { passive: true });
  window.addEventListener('click', unlock, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snap-panels"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('snap-panels-{{ section.id }}');
  if (!root) return;
  // optional viewport height correction for mobile
  const setSVH = () => { root.style.setProperty('--svh', window.innerHeight * 0.01 + 'px'); };
  setSVH(); window.addEventListener('resize', setSVH, { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
